import React from 'react'

const AutomationOptionsPushButton = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49" fill="none" className={className}>
    <path
      d="M45.36 1.5H3.82C2.5387 1.5 1.5 2.5387 1.5 3.82V45.36C1.5 46.6413 2.5387 47.68 3.82 47.68H45.36C46.6413 47.68 47.68 46.6413 47.68 45.36V3.82C47.68 2.5387 46.6413 1.5 45.36 1.5Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path d="M47.68 16.63H1.5V32.54H47.68V16.63Z" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
    <path
      d="M7.55055 10.7C8.37345 10.7 9.04055 10.0329 9.04055 9.20997C9.04055 8.38707 8.37345 7.71997 7.55055 7.71997C6.72764 7.71997 6.06055 8.38707 6.06055 9.20997C6.06055 10.0329 6.72764 10.7 7.55055 10.7Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M7.55055 26.08C8.37345 26.08 9.04055 25.4129 9.04055 24.59C9.04055 23.7671 8.37345 23.1 7.55055 23.1C6.72764 23.1 6.06055 23.7671 6.06055 24.59C6.06055 25.4129 6.72764 26.08 7.55055 26.08Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M7.55055 41.4101C8.37345 41.4101 9.04055 40.743 9.04055 39.9201C9.04055 39.0971 8.37345 38.4301 7.55055 38.4301C6.72764 38.4301 6.06055 39.0971 6.06055 39.9201C6.06055 40.743 6.72764 41.4101 7.55055 41.4101Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M41.6306 10.7C42.4535 10.7 43.1206 10.0329 43.1206 9.20997C43.1206 8.38707 42.4535 7.71997 41.6306 7.71997C40.8077 7.71997 40.1406 8.38707 40.1406 9.20997C40.1406 10.0329 40.8077 10.7 41.6306 10.7Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M41.6306 26.08C42.4535 26.08 43.1206 25.4129 43.1206 24.59C43.1206 23.7671 42.4535 23.1 41.6306 23.1C40.8077 23.1 40.1406 23.7671 40.1406 24.59C40.1406 25.4129 40.8077 26.08 41.6306 26.08Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M41.6306 41.4101C42.4535 41.4101 43.1206 40.743 43.1206 39.9201C43.1206 39.0971 42.4535 38.4301 41.6306 38.4301C40.8077 38.4301 40.1406 39.0971 40.1406 39.9201C40.1406 40.743 40.8077 41.4101 41.6306 41.4101Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
)

export default AutomationOptionsPushButton
